// Components/Loader.js
import React from 'react';
import './Loader.css'; // Import CSS for loader styles

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="loader-circle"></div>
        <div className="loader-circle"></div>
        <div className="loader-circle"></div>
      </div>
      <p className="loading-text">Welcome to Monitize-Media</p>
    </div>
  );
};

export default Loader;
